import SitemapHtml from './sitemap';

export default SitemapHtml;